import { useSearchParams } from 'react-router-dom';
import { IDateRangeFilterValue } from '../../common/date-range-filter/date-range-filter.interface';

// A Home-card click carries the exact date window its summary count was computed for (see
// operational-view.tsx's onSectionClick) alongside the `tab` param useShipmentTabParam reads.
// Their absence here means the page is being browsed normally (side-nav, typed URL, tab
// click) rather than arriving from a card click.
export function useShipmentsDateFilterParam(): IDateRangeFilterValue | null {
  const [searchParams] = useSearchParams();

  const fromDate = searchParams.get('fromDate');
  const toDate = searchParams.get('toDate');
  if (!fromDate || !toDate) return null;

  const dateFilterTypeParam = Number(searchParams.get('dateFilterType'));
  const dateFilterType =
    dateFilterTypeParam === 1 || dateFilterTypeParam === 2 || dateFilterTypeParam === 3
      ? dateFilterTypeParam
      : 2;

  return {
    fromDate: new Date(fromDate),
    toDate: new Date(toDate),
    dateFilterType
  };
}

export default useShipmentsDateFilterParam;
